import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class UcionicaService {

  constructor(private _http: Http) { }

  dohvatiPolaznike(ucionicaId: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_polaznike/', ucionicaId)
    .map(res => res.json());
  }

  dohvatiAktivnePolaznike(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_samo_polaznike', a)
    .map(res => res.json());
  }

  detaljiUcionice(ucionicaId: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_podatke_ucionice/', ucionicaId)
    .map(res => res.json());
  }

  addPolaznik_ucionica(polaznikPodaci: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_polaznik_add', polaznikPodaci)
    .map(res => res.json());
  }

  aktivirajPolaznik_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_polaznik_aktiviraj', a)
    .map(res => res.json());
  }

  deaktivirajPolaznik_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_polaznik_deaktiviraj', a)
    .map(res => res.json());
  }

  ocjeniPolaznik_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'polaznik_polozio_uredi', a)
    .map(res => res.json());
  }

  obrisiPolaznik_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_polaznik_delete', a)
    .map(res => res.json());
  }


  dohvatiVideozapise(ucionicaId: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_videozapise_ucionica', ucionicaId)
    .map(res => res.json());
  }


  addVideozapis_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_videozapis_add', a)
    .map(res => res.json());
  }

  urediVideozapis_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_video_uredi', a)
    .map(res => res.json());
  }

  obrisiVideozapis_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'videozapis_ucionice_delete', a)
    .map(res => res.json());
  }

  
  
  dohvatiDokumente(ucionicaId: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_pisanematerijale_ucionica', ucionicaId)
    .map(res => res.json());
  }

  addDokument_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_pisanimaterijal_add', a)
    .map(res => res.json());
  }

  urediDokument_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_pisanimaterijal_uredi', a)
    .map(res => res.json());
  }

  obrisiDokument_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_pisanimaterijal_delete', a)
    .map(res => res.json());
  }


  
  dohvatiAktivnePredavace(ucionicaId: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivne_predavace', ucionicaId)
    .map(res => res.json());
  }

  dohvatiPredavace(ucionicaId: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_predavace_ucionica', ucionicaId)
    .map(res => res.json());
  }

  addPredavac_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_predavac_add', a)
    .map(res => res.json());
  }

  obrisiPredavac_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_predavac_delete', a)
    .map(res => res.json());
  }



  posalji_email(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'slanje_emaila_polaznicima', a)
    .map(res => res.json());
  }


  dohvatiUvjerenja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_uvjerenja_ucionica', a)
    .map(res => res.json());
  }

  dohvatiVrsteuvjerenja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_vrsteuvjerenja', a)
    .map(res => res.json());
  }

  kreirajUvjerenja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kreiranje_uvjerenja', a)
    .map(res => res.json());
  }


  
  dohvatiKompetencije(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_kompetencije_ucionica', a)
    .map(res => res.json());
  }

  addsveKompetencije_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_sve_kompetencije_add', a)
    .map(res => res.json());
  }

  addjednaKompetencija_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_jedna_kompetencija_add', a)
    .map(res => res.json());
  }

  urediKompetencija_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_kompetencija_uredi', a)
    .map(res => res.json());
  }

  obrisiKompetencija_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_kompetencija_delete', a)    
    .map(res => res.json()); 
  }



  dohvatiModule(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_module_ucionica', a)
    .map(res => res.json());
  }

  dohvatiSastanke(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'prikaz_sastanaka', a)
    .map(res => res.json());
  }

  urediSastanak(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'promjena_statusa_sastanka', a)
    .map(res => res.json());
  }

  dohvatiVideozapisePolaznik(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_videozapise_polaznika_za_admina', a)
    .map(res => res.json());
  }

  dodjeliPregledaPolazniku(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dodjeli_broj_pregleda_polazniku', a)
    .map(res => res.json());
  }

  dohvatiEmailovePolaznik(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_mejlove_polaznika', a)
    .map(res => res.json());
  }

  gantogramPolaznik(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_podatke_gantogram_polaznik', a)
    .map(res => res.json());
  }
 
  dohvatiAktivneModuleUcionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivne_module_ucionica', a)
    .map(res => res.json());
  }

  dohvatiAktivneModule(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivne_module', a)
    .map(res => res.json());
  }

  dohvatiAktivneModuleNew(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivne_modulenew', a)
    .map(res => res.json());
  }

  addModul_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'ucionica_modul_add', a)
    .map(res => res.json());
  }

  urediModul_ucionica(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'ucionica_modul_uredi', a)
    .map(res => res.json());
  }

  obrisiModul_ucionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'modul_ucionica_delete', a)
    .map(res => res.json());
  }

  dohvatiDodaneModuleUcionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvatiModule', a)
    .map(res => res.json());
  }

  urediRbModulUcionica(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_redni_broj_modula', a)
    .map(res => res.json());
  }



  dohvatiPrisutnostUcionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_prisutnost_ucionica', a)
    .map(res => res.json());
  }

  urediPrisutnost_ucionica(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'ucionica_prisutnost_uredi', a)
    .map(res => res.json());
  }

  dohvatiPodatkeExcel(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_podatke_excel', a)
    .map(res => res.json());
  }


  dohvatiPodatkeGantogram(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_podatke_gantogram', a)
    .map(res => res.json());
  }

  // uredi_kriterij_testiranja_kompetencija(a: any){
  //   return this._http.put(AppConfig.apiAdresaSQL + 'uredi_kriterij_testiranja_kompetencija', a)
  //   .map(res => res.json());
  // }

  // dohvati_sve_ishode_nastavnih_jedinica(a: any){
  //   return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_ishode_nastavnih_jedinica', a)
  //   .map(res => res.json());
  // }

  dodaj_kriterij_testiranja_kompetencija(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dodaj_kriterij_testiranja_kompetencija', a)
    .map(res => res.json());
  }

  kriterijiPopis(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kriterij_testiranja_kompetencija', a)
    .map(res => res.json());
  }

  uredi_kriterij_testiranja_kompetencija(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_kriterij_testiranja_kompetencija', a)
    .map(res => res.json());
  }

  dohvati_sve_ishode_nastavnih_jedinica_za_ucionicu(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_ishode_nastavnih_jedinica_za_ucionicu', a)
    .map(res => res.json());
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ucionica-detalji/ucionica-detalji.service.ts